import styled from 'styled-components';

const SCustomMultiSelectWrapper = styled.div`
  .title {
    color: ${({ theme }) => theme.color};
  }
`;
export default SCustomMultiSelectWrapper;
